<div class="twc-container twc-m-2" style="max-width:100%">
    <div class="twc-row twc-col-12 twc-mb-2">
        <h3 class="twc-h3">
            <span><b>{{ 'UPLOAD.LAYER_TYPE' | translate}}: </b></span>
            <span class="twc-ml-3">{{'LAYER_SELECT.' + layerType | translate}}</span>
        </h3>
    </div>

    <div class="twc-row twc-col-12 twc-d-flex twc-mt-4 layer-options-container" *ngIf="noneSelected()">
        <button class="twc-button twc-button-secondary twc-p-5 " (click)="createNewLayer()"
            qaid="new-layer_button-create-layer">
            <twc-icon shape="add"></twc-icon>
            {{'LAYER_SELECT.CREATE_NEW' | translate}}
        </button>

        <button class="twc-button twc-button-secondary twc-p-5" (click)="selectLayer()"
            qaid="new-layer_button-select-existing-layer">
            <twc-icon shape="layer"> </twc-icon>
            {{'LAYER_SELECT.SELECT_EXISTING' | translate}}
        </button>
    </div>
    <cw-select-new-layer (closeClick)="resetLayerSelectionMode()" *ngIf="newSelected()"></cw-select-new-layer>
    <cw-select-existing-layer *ngIf="existingSelected()" [isMultiSelection]="false" [isWizard]="true"
        (closeClick)="resetLayerSelectionMode()">
    </cw-select-existing-layer>
</div>